/* Edited by Jonathan <jonathan@birubi.co> */
/*
 * EquaVetz desktop product-gallery enhancement.
 *
 * Dawn already wires each thumbnail button to switch the main image
 * (media-gallery.js -> setActiveMedia, which flags the active thumbnail with
 * aria-current="true"). This script reuses that mechanism to drive two things
 * the Figma design (142:1142) adds on desktop:
 *   1. the main image < / > arrows (Dawn hides them on desktop), and
 *   2. a row of carousel dots below the thumbnails.
 *
 * Both simply move/click through the thumbnail buttons, so image switching,
 * variant swaps and accessibility state stay 100% native. Desktop-gated so
 * mobile keeps Dawn's own slider untouched.
 *
 * It also re-parents the system banner into the photo frame. See anchorBanner
 * below: that part is NOT desktop-gated and runs for every gallery.
 */
(function () {
  var DESKTOP = '(min-width: 750px)'; /* keep in sync with the ev-pdp.css gallery block */

  function initGallery(gallery) {
    if (gallery.dataset.evGalleryReady) return;

    var thumbsRoot = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbsRoot) return;

    var thumbs = Array.prototype.slice.call(
      thumbsRoot.querySelectorAll('.thumbnail-list__item .thumbnail')
    );
    if (thumbs.length < 2) return;

    gallery.dataset.evGalleryReady = 'true';

    function activeIndex() {
      var i = thumbs.findIndex(function (b) {
        return b.getAttribute('aria-current') === 'true';
      });
      return i < 0 ? 0 : i;
    }

    function go(index) {
      var n = thumbs.length;
      thumbs[((index % n) + n) % n].click();
    }

    // --- Repurpose the main viewer arrows for thumbnail navigation (desktop only) ---
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var prev = viewer && viewer.querySelector('.slider-button--prev');
    var next = viewer && viewer.querySelector('.slider-button--next');

    function arrow(direction) {
      return function (event) {
        // On mobile, let Dawn's native slider handle the arrows.
        if (!window.matchMedia(DESKTOP).matches) return;
        event.stopImmediatePropagation();
        event.preventDefault();
        go(activeIndex() + direction);
      };
    }

    // Capture phase + stopImmediatePropagation pre-empts Dawn's own handler.
    if (prev) prev.addEventListener('click', arrow(-1), true);
    if (next) next.addEventListener('click', arrow(1), true);

    // --- Build the dots ---
    var dotsEl = document.createElement('div');
    dotsEl.className = 'ev-gallery-dots';

    var dots = thumbs.map(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ev-gallery-dot';
      dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
      dot.addEventListener('click', function () {
        go(i);
      });
      dotsEl.appendChild(dot);
      return dot;
    });

    gallery.appendChild(dotsEl);

    function syncDots() {
      var active = activeIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === active);
      });
    }

    syncDots();

    // aria-current flips whenever the active media changes (thumbnail click,
    // arrow, dot, or variant swap), mirror it onto the dots.
    var observer = new MutationObserver(syncDots);
    thumbs.forEach(function (b) {
      observer.observe(b, { attributes: true, attributeFilter: ['aria-current'] });
    });
  }

  /*
   * Move the system banner (snippets/ev-system-banner.liquid) out of the
   * gallery viewer and into each photo frame.
   *
   * Liquid renders it once, as a child of the viewer, because that is the only
   * place in main-product.liquid it can be injected without editing Dawn's
   * 100KB section. But the viewer is NOT the photo: Dawn insets the slide
   * inside it by an amount that changes with the gallery layout, the
   * breakpoint and whether a next slide is peeking. Positioning the band
   * against the viewer therefore meant hardcoding those insets, and they were
   * wrong below 750px, where ev-pdp.css does not style the gallery at all --
   * the band overhung the photo and sat above its top edge.
   *
   * `.product-media-container` IS the photo frame and is already
   * position: relative, so once the band is inside it, `top: 0` and a centred
   * `width: 80%` are exact on every breakpoint with no magic numbers.
   *
   * One copy per frame rather than one moved into the first: Dawn switches
   * slides by showing and hiding them, so a single copy would disappear the
   * moment anyone viewed the second image.
   *
   * Runs for every gallery, at every width, however many images there are --
   * deliberately outside initGallery, which bails early on single-image
   * products and on layouts without thumbnails.
   */
  function anchorBanner(gallery) {
    var source = gallery.querySelector('[id^="GalleryViewer"] > .ev-system-banner');
    if (!source) return;

    var frames = gallery.querySelectorAll('[id^="GalleryViewer"] .product-media-container');
    if (!frames.length) return;

    frames.forEach(function (frame) {
      if (frame.querySelector('.ev-system-banner')) return;
      frame.appendChild(source.cloneNode(true));
    });

    source.remove();
  }

  function initAll() {
    document.querySelectorAll('media-gallery').forEach(anchorBanner);

    document
      .querySelectorAll('media-gallery[data-desktop-layout*="thumbnail"]')
      .forEach(initGallery);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  // Theme editor re-renders the section on every setting change, replacing the
  // gallery DOM (and with it the dots + listeners), re-init on each render.
  document.addEventListener('shopify:section:load', initAll);
})();